(() => {
  if (window.__iuropC2MotionInit) return;
  window.__iuropC2MotionInit = true;

  const root = document.documentElement;
  let observer = null;

  const revealSection = (section) => {
    section.classList.add("is-inview");
  };

  const setupAnimations = () => {
    const sections = Array.from(document.querySelectorAll(".iurop-c2"));
    if (!sections.length) return;

    root.classList.add("iurop-motion-ready");

    if (!("IntersectionObserver" in window)) {
      sections.forEach(revealSection);
      return;
    }

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealSection(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    sections.forEach((section, index) => {
      section.style.setProperty("--iurop-c2-reveal-index", String(index));
      if (section.classList.contains("is-inview")) return;
      observer.observe(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupAnimations, { once: true });
  } else {
    setupAnimations();
  }

  document.addEventListener("shopify:section:load", setupAnimations);
  document.addEventListener("shopify:section:reorder", setupAnimations);
})();
